import { render, staticRenderFns } from "./Canceldialog_helthcheck.vue?vue&type=template&id=61b70738&scoped=true&"
import script from "./Canceldialog_helthcheck.vue?vue&type=script&lang=js&"
export * from "./Canceldialog_helthcheck.vue?vue&type=script&lang=js&"
import style0 from "./Canceldialog_helthcheck.vue?vue&type=style&index=0&id=61b70738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b70738",
  null
  
)

export default component.exports